export const LOGIN = "LOGIN";
export const CUSTOMER_SEARCH = "CUSTOMER_SEARCH";
export const DESTROY_SESSION = "DESTROY_SESSION";
